import { useState } from "react";
import { Search, MoreVertical, ArrowLeft } from "lucide-react";
import { DropdownMenu } from "./DropdownMenu"
import type { MenuAction } from "../../../types/index";

interface ChatHeaderProps {
  avatar: string;
  name: string;
  role: string;
  messageSearch: string;
  onMessageSearchChange: (value: string) => void;
  onBackClick?: () => void;
  isMobile: boolean;
  onMenuAction: (action: MenuAction) => void;
  isPinned?: boolean;
}

export function ChatHeader({
  avatar,
  name,
  role,
  messageSearch,
  onMessageSearchChange,
  onBackClick,
  isMobile,
  onMenuAction,
  isPinned,
}: ChatHeaderProps) {
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="sticky top-0 z-20 bg-[#F6F8F9] border-b border-gray-200">
      <div className="p-3 md:p-4 flex flex-col md:flex-row md:items-center gap-2 md:gap-0">
        <div className="flex items-center">
          {isMobile && onBackClick && (
            <button
              onClick={onBackClick}
              className="mr-2 text-gray-500 hover:text-gray-600"
            >
              <ArrowLeft className="w-6 h-6" />
            </button>
          )}
          <img
            src={avatar}
            alt={name}
            className="w-8 h-8 md:w-10 md:h-10 rounded-full"
          />
          <div className="flex flex-col">
            <div className="ml-2 flex items-center">
              <h2 className="text-base md:text-lg font-medium text-gray-900">
                {name}
              </h2>
            </div>
            <p className="text-xs md:text-sm text-gray-500 ml-2">{role}</p>
          </div>
        </div>
        <div className="md:ml-auto flex items-center space-x-2 md:space-x-4">
          <div
            className={`relative flex-1 md:flex-none transition-all duration-200 ${
              isSearchVisible ? "w-full md:w-48" : "w-0"
            }`}
          >
            {isSearchVisible && (
              <input
                type="text"
                placeholder="Rechercher..."
                value={messageSearch}
                onChange={(e) => onMessageSearchChange(e.target.value)}
                className="w-full px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            )}
          </div>
          <button
            onClick={() => setIsSearchVisible(!isSearchVisible)}
            className="text-gray-400 hover:text-gray-600 p-1"
          >
            <Search className="w-5 h-5" />
          </button>
          <div className="relative">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-400 hover:text-gray-600 p-1"
            >
              <MoreVertical className="w-5 h-5" />
            </button>
            <DropdownMenu
              isOpen={isMenuOpen}
              onClose={() => setIsMenuOpen(false)}
              onAction={onMenuAction}
              isPinned={isPinned}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
